import React, { useState, useContext } from "react";
import "./SectionToolbar.scss";
import SwitchButton from "../Buttons/SwitchButton/SwitchButton";
import { pageLayoutContext } from "../../Context/PageLayoutContext";
import ReactTooltip from "react-tooltip";
import OutsideClickHandler from "react-outside-click-handler";
import { userTypeContext } from "../../Context/FreeOrProContext";
import { profileImageTypes } from "../../TemplateConfig";

function SectionItemToolbar(props) {
  const [showSettings, setShowSettings] = useState(false);
  const [showIconSettings, setShowIconSettings] = useState(false);

  const { reArrangeStatus, setReArrangeStatus } = useContext(pageLayoutContext);
  const { userType, resumeCount, showProPopup, setShowProPopup } =
    useContext(userTypeContext);
  const handleSettings = () => {
    setShowSettings(!showSettings);
  };
  const handleIconSettings = () => {
    setShowIconSettings(!showIconSettings);
  };
  const changeRearrangeStatus = () => {
    setReArrangeStatus(!reArrangeStatus);
  };

  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  const handleProfileImageType = (type) => {
    props.handleProfileImageChange(type);
  };

  return (
    <>
      <ReactTooltip />
      <div className="row global_toolbar_main main_toolbar">
        <div className="global_toolbar_container">
          <div className="d-flex global_toolbar_inner">
            <div className="justify-content-between section_tools">
              {props && props.sectionId == "profile" ? (
                <a className="section-handler">
                  <span
                    data-tip="Add Fields"
                    onClick={() =>
                      props.handleAddAdditionalField(
                        props.sectionRef,
                        props && props.resumeFields && props.resumeFields.data
                      )
                    }
                  >
                    <i className="fa fa-plus" aria-hidden="true"></i>
                  </span>
                </a>
              ) : (
                ""
              )}
              {(props && props.sectionId == "profile") ||
              (props && props.sectionId == "summary") ? (
                ""
              ) : (
                //   <a className="section-handler">
                //     <span onClick={props.editPopupShow}>
                //       <i className="fa fa-pencil" aria-hidden="true"></i>
                //     </span>
                //   </a>
                <>
                  {props && props.sectionId.includes("custom") ? (
                    ""
                  ) : (
                    <>
                      <a className="section-handler">
                        <span
                          data-tip="Add section"
                          onClick={() =>
                            props.addAdditionalField(
                              props.sectionRef,
                              props &&
                                props.resumeFields &&
                                props.resumeFields.data,
                              props.sectionId
                            )
                          }
                        >
                          <i className="fa fa-plus" aria-hidden="true"></i>
                        </span>
                      </a>
                    </>
                  )}

                  {props && props.indexString && props.indexString != "0" && (
                    <>
                      <a className="section-handler">
                        <span
                          data-tip="Move up"
                          onClick={(e) =>
                            props.sectionMoveUp(props.layout, props.sectionId)
                          }
                        >
                          <i className="fa fa-arrow-up" aria-hidden="true"></i>
                        </span>
                      </a>
                    </>
                  )}

                  {props.row.length != props.index + 1 && (
                    <>
                      <a className="section-handler">
                        <span
                          data-tip="Move Down"
                          onClick={(e) =>
                            props.sectionMoveDown(props.layout, props.sectionId)
                          }
                        >
                          <i
                            className="fa fa-arrow-down"
                            aria-hidden="true"
                          ></i>
                        </span>
                      </a>
                    </>
                  )}

                  <a className="section-handler">
                    <span
                      data-tip="Delete"
                      onClick={() =>
                        props.deletePopupShow(props.layout, props.sectionId)
                      }
                    >
                      <i className="fa fa-trash" aria-hidden="true"></i>
                    </span>
                  </a>
                </>
              )}
            </div>

            <div className="justify-content-between description_tools">
              {props && props.sectionId == "profile" ? (
                <a>
                  <span
                    data-tip="Settings"
                    className="section-settings"
                    onClick={handleSettings}
                  >
                    <i className="fa fa-cog" aria-hidden="true"></i>
                  </span>
                </a>
              ) : (
                <>
                  <a onClick={changeRearrangeStatus}>
                    <span data-tip="Rearrange">
                      <i className="fa fa-th" aria-hidden="true"></i>
                    </span>
                  </a>
                  <a>
                    <span
                      data-tip="Settings"
                      className="section-icon-settings"
                      onClick={handleIconSettings}
                    >
                      <i className="fa fa-cog" aria-hidden="true"></i>
                    </span>
                  </a>
                </>
              )}
            </div>

            {showSettings && showSettings && (
              <OutsideClickHandler
                onOutsideClick={(e, value) => {
                  const parentWithClass = e.target.closest(
                    ".profile_settings_div"
                  );
                  const anotherParentWithClass =
                    e.target.closest(".section-settings");
                  if (
                    showSettings &&
                    showSettings &&
                    parentWithClass == null &&
                    anotherParentWithClass == null
                  ) {
                    handleSettings();
                  }
                }}
              >
                <div className="profile_settings_div">
                  {props && props.sectionId == "profile" && (
                    <div className="d-flex justify-content-between">
                      <p className="">Image Style:</p>
                      <div>
                        {profileImageTypes?.map((res, index) => (
                          <div
                            className={`skill-slider-type mt-2 ${
                              props?.settings?.profile?.photoStyle === res
                                ? "green-slider"
                                : ""
                            }`}
                            onClick={() => handleProfileImageType(res)}
                          ></div>
                        ))}
                      </div>
                    </div>
                  )}
                  {props &&
                  props.sectionId == "profile" &&
                  userType == "pro" ? (
                    <>
                      <div
                        className="d-flex justify-content-between"
                        onClick={() => props.handleBackground()}
                      >
                        <p>Show Background:</p>
                        <SwitchButton
                          checked={
                            props && props.background && props.background.bgShow
                          }
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  {props &&
                    props.resumeFields &&
                    props.resumeFields.data &&
                    props.resumeFields.data[props.index].showFields &&
                    Object.keys(
                      props &&
                        props.resumeFields &&
                        props.resumeFields.data &&
                        props.resumeFields.data[props.index].showFields &&
                        props.resumeFields.data[props.index].showFields
                    ).map((res, index) => {
                      var showText = "";
                      if (res.includes("customField")) {
                        showText = `Custom field-${res.split("_")[1]}`;
                      } else if (res.includes("custom")) {
                        showText = `${res.split("_")[1]}`;
                      } else {
                        showText = res;
                      }
                      return (
                        <>
                          <div
                            className="d-flex justify-content-between"
                            onClick={() =>
                              props.changeSettings(res, props.index)
                            }
                          >
                            <p>Show {capitalize(showText)}:</p>
                            <SwitchButton
                              checked={
                                props &&
                                props.resumeFields &&
                                props.resumeFields.data &&
                                props.resumeFields.data[props.index].showFields[
                                  res
                                ]
                              }
                            />
                          </div>
                        </>
                      );
                    })}
                </div>
              </OutsideClickHandler>
            )}

            {showIconSettings && showIconSettings && (
              <OutsideClickHandler
                onOutsideClick={(e, value) => {
                  const parentWithClass = e.target.closest(
                    ".profile_icon_settings_div"
                  );
                  const anotherParentWithClass = e.target.closest(
                    ".section-icon-settings"
                  );
                  if (
                    showSettings &&
                    showSettings &&
                    parentWithClass == null &&
                    anotherParentWithClass == null
                  ) {
                    handleIconSettings();
                  }
                }}
              >
                <div className="profile_icon_settings_div">
                  <div
                    className="d-flex justify-content-between"
                    onClick={() => props.changeIconSettings()}
                  >
                    <p>Show Icon:</p>
                    <SwitchButton
                      checked={
                        props && props.settings && props.settings.showIcon
                      }
                    />
                  </div>
                </div>
              </OutsideClickHandler>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default SectionItemToolbar;
